import { CodeSystem } from "@intocare/datatypes/lib/code-system";

export const PART_OF_DAY = {
	name: "PART_OF_DAY",
	concept: {
		AFTERNOON: {
			display: {
				"nl-BE": "Namiddag",
				"fr-BE": "Après-midi",
			},
		},
		EVENING: {
			display: {
				"nl-BE": "Avond",
				"fr-BE": "Soir",
			},
		},
		MORNING: {
			display: {
				"nl-BE": "Ochtend",
				"fr-BE": "Matin",
			},
		},
		NIGHT: {
			display: {
				"nl-BE": "Nacht",
				"fr-BE": "Nuit",
			},
		},
	},
} as const satisfies CodeSystem;
